import { Box } from '@mui/material';
import { Form } from 'formik';
import type { PropsWithChildren } from 'react';

export const DialogForm = ({ children }: PropsWithChildren) => (
  <Box
    component={Form}
    noValidate
    sx={{
      display: 'flex',
      flexDirection: 'column',
      flex: '1 1 auto',
      minHeight: 0,
      overflow: 'hidden',
    }}
  >
    {children}
  </Box>
);
